import React from 'react';

import { LanguageSwitcher as RDCLanguageSwitcher } from '@uncinc/react-drupal-core';

import { DEFAULT_LANGUAGE, SEARCH_PATH } from '../../config/constants';

import './style.scss';

interface LanguageSwitchProps {
  buttonRef?: React.RefObject<HTMLAnchorElement>;
}

const LanguageSwitcher: React.FC<LanguageSwitchProps> = ({ buttonRef }) => (
  <RDCLanguageSwitcher
    languages={{ en: 'EN', nl: 'NL' }}
    defaultLanguage={DEFAULT_LANGUAGE}
    firstLanguageRef={buttonRef}
    hideActive={false}
    customRoutes={[SEARCH_PATH]}
  />
);

export default LanguageSwitcher;
